import getMissedBreaks from '@sdk/automatedBreaks/helpers/getMissedBreaks';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';
import { AutomatedBreakType } from '@sdk/settings/types';

import { TimeClockEntryWithDates } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import { GetSummaryProps } from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/durationRow.types';
import {
  takenBreaksSummary,
  getSummariesTextToDisplay,
} from '@web/timeClock/modals/rows/ActualRow/clockInSummary.utils';

export const getSummary = ({
  timeClockEntries,
  timesheetEntries,
  breakAttestations,
}: GetSummaryProps) => {
  const allBreakRecords = [];
  let allMissedMealBreaks = 0;
  let allMissedRestBreaks = 0;

  timeClockEntries.forEach((timeClockEntry: TimeClockEntryWithDates) => {
    const { key, clockIn, clockOut, breaks } = timeClockEntry;
    const relevantTimesheetEntries = timesheetEntries[key];

    const replacedAttestations = new Set(
      breaks
        .filter((b) => b.replacesAttestedBreakNumber)
        .map((b) => `${b.type}_${b.replacesAttestedBreakNumber}`)
    );

    const relevantAttestations = breakAttestations?.filter(
      ({ baseSequenceId, breakNumber, breakType }) =>
        baseSequenceId === timeClockEntry.baseSequenceId &&
        !replacedAttestations.has(`${breakType}_${breakNumber}`)
    );

    const { breakRecords } = getBreaksSummary(
      relevantTimesheetEntries,
      clockIn,
      clockOut,
      relevantAttestations
    );

    allBreakRecords.push(...breakRecords);

    const missedBreaks = getMissedBreaks(relevantTimesheetEntries, clockOut, relevantAttestations);
    allMissedMealBreaks =
      allMissedMealBreaks + (missedBreaks[AutomatedBreakType.meal]?.length || 0);
    allMissedRestBreaks =
      allMissedRestBreaks + (missedBreaks[AutomatedBreakType.rest]?.length || 0);
  });

  const summary = takenBreaksSummary(allBreakRecords, breakAttestations);
  const summariesToDisplay = getSummariesTextToDisplay(summary, {
    meal: allMissedMealBreaks,
    rest: allMissedRestBreaks,
  });

  return summariesToDisplay;
};
